module.exports = __webpack_public_path__ + "img/cover-1.b4fe3a02.png";